import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseCompaniesProps<T> = {
  filters?: {
    search?: string
    page?: number
    kind?: string
    status?: string
    paymentModality?: string
    commercialManagerId?: string
    maximumConsumption?: string
  }
  mapper?: (data: any) => T,
}

export const useCompanies = <T,>({
  filters: { search = '', page, kind, status, paymentModality, commercialManagerId, maximumConsumption } = {},
  mapper = Mapper.default<T>(),
}: UseCompaniesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['companies', search, page, kind, status, paymentModality, commercialManagerId, maximumConsumption],
    queryFn: () => {
      return privateAxios.get('/client/companies', {
        params: {
          search,
          page,
          'q[kind_eq]': kind,
          'q[status_eq]': status,
          'q[payment_modality_eq]': paymentModality,
          'q[commercial_manager_id_eq]': commercialManagerId,
          'q[consumed_total_lteq]': maximumConsumption?.trim().replace(/\./g, "").replace(/,/g, ".")
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
